// src/components/PrivateComponent.js
import React from "react";
import { useLocation, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

function PrivateComponent({ component: WrappedComponent }) {
  const location = useLocation();
  // ✅ تغییر از userLogin به auth
  const { userInfo } = useSelector((state) => state.auth) || {};
  const isAuthenticated = userInfo && userInfo.access ? true : false;
  const redirect = encodeURIComponent(location.pathname + location.search);

  if (!isAuthenticated) {
    return <Navigate to={`/phone?redirect=${redirect}`} />;
  }

  return <WrappedComponent />;
}

PrivateComponent.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default PrivateComponent;